import React, { useEffect, useState } from 'react';
import './App.css';
import Footer from './component/layout/Footer';
import Navbar from './component/layout/Navbar';
import Loader from './component/loader/Loader';
import Home from './component/home/Home';
import About from './component/about/About';
import Gallery from './component/gallery/Gallery';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Founder from './component/founder/Founder';
import NotFound from './component/notfound/NotFound';
import UnderConstruction from './component/underconstruction/UnderConstruction';
import Contact from './component/contact/Contact';
import OurWork from './component/ourwork/OurWork';
import ScrollToTop from './component/layout/ScrollToTop';

function App() {
  const [loading, setLoading] = useState(true)

  useEffect(()=>{
    const timer = setTimeout(() => setLoading(false), 1500);
    return () => clearTimeout(timer);
  },[]);

  return (
    <div className="App">
      {loading ? (
        <Loader />
      ) : (
      <div className="page-content">  
        <Router>
          <ScrollToTop />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/founder" element={<Founder />} />
            <Route path="/our-work" element={<OurWork />} />
            <Route path="/gallery" element={<Gallery />} />
            {/* <Route path="/gallery" element={<UnderConstruction />} /> */}
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
        </Router>
      </div>
      )}
    </div>
  );
}

export default App;
